import PropTypes from 'prop-types';

const getImageFileName = (image) => {
  if (image?.fileName) return image.fileName;
  if (image?.filename) return image.filename;
  const url = image?.imageUrl || '';
  if (!url) return '';
  try {
    return decodeURIComponent(new URL(url).pathname.split('/').pop() || '');
  } catch {
    return decodeURIComponent(url.split('/').pop() || '');
  }
};

const PepIrisImageReviewRow = ({label, image, testId}) => {
  const fileName = getImageFileName(image);
  const previewUrl = image?.imageUri || image?.imageUrl || '';

  return (
    <div className='flex items-start gap-4' data-testid={testId}>
      {previewUrl ? (
        <img
          src={previewUrl}
          alt={label}
          className='h-[72px] w-[72px] rounded object-cover'
          data-testid={`${testId}-image`}
        />
      ) : (
        <div
          className='h-[72px] w-[72px] rounded border border-dashed border-[color:var(--color-border-default)]'
          data-testid={`${testId}-empty`}
        />
      )}
      <div>
        <p className='review_subtitle'>{label}</p>
        <span className='review_title'>{fileName || '-'}</span>
      </div>
    </div>
  );
};

PepIrisImageReviewRow.propTypes = {
  label: PropTypes.string.isRequired,
  image: PropTypes.shape({
    imageUrl: PropTypes.string,
    imageUri: PropTypes.string,
    fileName: PropTypes.string,
    filename: PropTypes.string
  }),
  testId: PropTypes.string.isRequired
};

export default PepIrisImageReviewRow;
